<template>
	<div class="sidebar">
		<el-popover v-model="showPopover" popper-class="sidebar_popover" placement="right" title="" trigger="hover" width="380">
			<div class="sidebar_view">
				<!-- <div class="title">{{item.title}}</div> -->
				<div class="navigation" v-for="(two,two_k) in item.child">
					<div class="navigation_two title">{{two.title}}</div>
					<div class="navigation_therr">
						<div class="navigation_therr_span"  @click="onClickItem()" v-for="(therr,therr_k) in two.child">
							<el-link type="primary" target="_blank"
								:href="therr.path == '/vvbSupply' ? pathList[0] : therr.path == '/vvbOnlineSelection' ? pathList[1] : ''"
								v-if="therr.path == '/vvbSupply' || therr.path == '/vvbOnlineSelection'" >
								{{therr.name}}
							</el-link>
							<router-link tag="span" class="cursor" :to="(therr.path + '?' + therr.param).replace('?undefined', '')" 
                            @click.native="clink((therr.path + '?' + therr.param).replace('?undefined', ''), therr.param && therr.param.replace('?undefined', '') ? (two.title + '-' + therr.name) : '')" v-else>
								{{therr.name}}
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="sidebar_btn" :class="{title:item.checked}" slot="reference" @click="onNavTo(item)">
				<el-image class="icon" :src="item.icon" v-if="item.icon.indexOf('http')==0"/>
				<i :class="'icon '+item.icon" v-else></i>
				<div>{{item.name}}</div>
			</div>
		</el-popover>
	</div>
</template>

<script>
	export default {
		name: 'SidebarItem',
		props: {
			item: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				showPopover: false,
				pathList:['https://www.douhuomall.com/index.php/manager/login/index','https://www.douhuomall.com/choice/v3/#/index']
			}
		},
		methods: {
			onNavTo(item){
				let path = item.child[0]&&item.child[0].child&&item.child[0].child[0] ? item.child[0].child[0].path : item.path;
				this.$router.push({path});
				this.onClickItem();
			},
			onClickItem(){
				this.$emit('onClickItem',this.item)
			},
            clink(fullPath, name){
                if(name){
                    this.$bus.$emit('activeMenuName', {fullPath, name});
                }
                this.showPopover = false;
            },
		}
	}
</script>

<style s>
	.sidebar {
		display: flex;
		flex-direction: column;
		height: 66px;
	}

	.sidebar_view {
		width: 150px;
		/* min-height: 150px; */
		display: flex;
		flex-direction: column;
	}

	/* ::-webkit-scrollbar {
		width: 2px;
	} */

	.navigation{
		width: 380px;
	}
	.navigation_two{
		padding: 7px;
		font-weight: bold;
		margin-top: 5px;
	}
	.navigation:first-child .navigation_two{
		margin-top: 0;
	}
	.navigation_therr{
		width: 100%;
		display: flex;
		flex-flow: wrap;
	}
	.navigation_therr_span{
		min-width: 110px;
		padding: 7px;
	}
	.navigation_therr_span:hover .cursor{
		cursor: pointer;
		color: var(--theme-color);
	}
	
	.sidebar_btn {
		width: 66px;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		color: #fff;
		cursor: pointer;
		margin-top: 20px;
		.icon{
			font-size: 30px;
		}
	}

	.icon {
		width: 26px;
		height: 24px;
		margin-bottom: 5px;
	}

	.sidebar_popover {
		display: flex;
		background: #fff;
		border: 1px solid var(--theme-color);
		margin-top: 76px;
		height: auto;
	}

	.sidebar_popover[x-placement^='right'] .popper__arrow {
		border-right-color: var(--theme-color);
		top: 30px !important;
	}

	.sidebar_title {
		font-size: 14px;
		color: var(--theme-color);
	}

	.sidebar_link {
		display: inline-block;
		font-size: 14px;
		color: #333;
		margin-top: 10px;
		:hover {
			color: var(--theme-color);
			border-bottom: 1px solid var(--theme-color);
		}
	}
	
	.title {
		font-size: 14px;
		color: var(--theme-color);
	}
	
</style>